import { NextApiRequest, NextApiResponse } from 'next'

import { STAGING_HOST } from '../constants'

// sync with `network-graphql-playground` in .juscli
const LOCAL_GRAPHQL = 'http://localhost:4500/graphql'

export async function graphqlMiddleware(req: NextApiRequest, res: NextApiResponse) {
  const host = req.headers.host
  const isStagingHost = host?.includes(STAGING_HOST)
  const isCI = !!process.env.CI

  if (process.env.NODE_ENV !== 'development' && !isCI && !isStagingHost) {
    return res.status(404).send(null)
  }

  const url = process.env.NETWORK_GRAPHQL_PLAYGROUND_URL || LOCAL_GRAPHQL
  const urlWithBatch = req.url?.endsWith('/apollo-batch') ? `${url}/apollo-batch` : url

  const headers: HeadersInit = {
    Cookie: req?.headers.cookie || '',
    'User-Agent': req?.headers['user-agent'] || '',
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
  const cfConnectingIpHeader = req?.headers['cf-connecting-ip']
  if (cfConnectingIpHeader) {
    headers['CF-Connecting-IP'] = Array.isArray(cfConnectingIpHeader)
      ? cfConnectingIpHeader.join('; ')
      : cfConnectingIpHeader
  }

  const serviceAccountAccessToken = process.env.SA_ACCESS_TOKEN
  if (serviceAccountAccessToken) {
    headers.Authorization = `Bearer ${serviceAccountAccessToken}`
  }

  if (req?.headers.authorization) {
    headers.Authorization = req.headers.authorization
  }

  let response: Response
  try {
    response = await fetch(urlWithBatch, {
      method: req.method,
      body: JSON.stringify(req.body),
      headers,
    })
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error)
    return res.json({
      data: null,
      errors: [
        {
          message: `[core-next] Failed to connect to GraphQL at ${urlWithBatch}: ${message}. Run "jus configure" to set up the server.`,
        },
      ],
    })
  }

  const setCookies: string[] = []
  response.headers.forEach((value, key) => {
    if (key.toLowerCase() === 'set-cookie') setCookies.push(value)
  })
  res.setHeader('Set-Cookie', setCookies)

  const contentType = response.headers.get('content-type') || ''
  if (!contentType.includes('application/json')) {
    return res.json({
      data: null,
      errors: [
        {
          message: `[core-next] Unexpected response from GraphQL at ${urlWithBatch}: "${contentType}" (HTTP ${response.status}). The server may be down or misconfigured.`,
        },
      ],
    })
  }

  const data = await response.json()
  return res.json(data)
}
